import PropTypes from 'prop-types';
import classNames from 'classnames';

import { checkUniquePropType } from '../utils/checkUniquePropType';

import styles from './IconWithText.module.scss';

// Styles

const cx = classNames.bind(styles);

const IconWithText = ({
  title = '',
  content = '',
  className = '',
  iconUrl = '',
  children = null,
  subtitle = '',
  theme = 'default',
  contentFontStyle = 'italic'
}) => {
  const IconWithTextClassName = cx(styles.root, styles[theme], className);
  const IconWithTextContent = cx(styles.content, styles[contentFontStyle]);

  return (
    <div className={IconWithTextClassName}>
      {iconUrl && (
        <figure className={styles.image}>
          <img src={iconUrl} alt="" />
        </figure>
      )}

      {children && children}

      <h3 className={styles.title}>{title}</h3>

      {subtitle && <p className={styles.subtitle}>{subtitle}</p>}

      <p className={IconWithTextContent}>{content}</p>
    </div>
  );
};

IconWithText.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  content: PropTypes.string,
  className: PropTypes.string,
  iconUrl: checkUniquePropType,
  children: checkUniquePropType,
  theme: PropTypes.oneOf(['default', 'light', 'dark']),
  contentFontStyle: PropTypes.oneOf(['italic', 'normal'])
};

export default IconWithText;
